import { render, staticRenderFns } from "./InventoryItems.vue?vue&type=template&id=73c3b41d"
import script from "./InventoryItems.vue?vue&type=script&lang=js"
export * from "./InventoryItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports